import React from "react";

const Cousin = () => {
  return (
    <div>
      <h4>Cousin</h4>
    </div>
  );
};

export default Cousin;
